export default {
  shopify: {
    defaultLanguage: 'en',
    en: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vS5YO_nu7sgHsOIqIyjaiA4JaIRjLgbj0-DNmLn5Vmu5dABoVnQe0WMMouLWC3Y-J30a7lBR7z6DLLP/pub',
    },
  },
  prestaShop16: {
    defaultLanguage: 'cs',
    cs: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vRQ_kLlpQzqROUKPhPjQ-ti_Ldcgvf0q--LJnaFczXtBjjbUSTXAO7h1qs7EhbKxdVods_3HbIbfyXm/pub',
    },
  },
  prestaShop17: {
    defaultLanguage: 'cs',
    cs: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vTHTypqwLQ7aGSLvu2hqf5ejbUvl1AeWVlDN0SFdJyHGQYx4Xib6HWeacGQDkKrbjYKNOPkY3fN8z7C/pub',
    },
  },
  eshoprychle: {
    defaultLanguage: 'cs',
    cs: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vT_5xaVhCJ5l0P2lIjMJ5xiICpRGI2hpWWXA44uCEZFgAh7GVGqINOU13Upp9C8cTuBbr82xfVRchsz/pub',
    },
  },
  fastcentrik: {
    defaultLanguage: 'cs',
    cs: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vSG7trXhlsFwKJUd6YC2-WnLbKzh1Rg1pUf7uN6BVI4uPJ9GJ9cF1HHB0UggKDQBnsBhGYmVKH1zjAU/pub',
    },
  },
  shoptet: {
    defaultLanguage: 'cs',
    cs: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vSiaAtJ537mdufigKDQeUtwHbhhOS82XExHHeZ9kMhjN-njxVvd11wuiw_Z5o_e8FvlxjkF9eGkmD3J/pub',
    },
  },
  flox3: {
    defaultLanguage: 'cs',
    cs: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vT8sYTfP1-3y4Ro4tHKAzF4srJX2o2YZHntPo9lHLAUM4lm8IswuekU6omnX8kjsbnT2y-c10AHYpzm/pub',
    },
  },
  businessUserGuide: {
    defaultLanguage: 'en',
    cs: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vT3Hlu2wxlhLBdVqMMwfdhVDYirP_gexJ5XeKbR-ZmJ1snoGVjPKhJ75SoVH3C-_0gWqNoZm_oaRuqB/pub',
    },
    en: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vQh0gPm3bdSxECGvYGb4n-uyONlQcf6_cXNJNgj7-qEtnTaWlEl8WKA1sRYdAzsq5y7_x9J2M7Slb-Y/pub',
    },
  },
  analyticsIntegrationManual: {
    defaultLanguage: 'cs',
    cs: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vRHI4kgLQa3AEk3iBvxq6q5kDlbXvUEXQtF7EVTXYYfWQtk3Zg-cLsh-23_Qk5dMOYMd7kzf2HH8iKI/pub',
    },
  },
  advisorIntegrationGuide: {
    defaultLanguage: 'en',
    cs: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vRDsd03pVCNkGM95pX_1XcECOFu49pY29chSS0tvYYCFsmJgfZrMdqbgEIqvReALxL0vXy6aZnQAbHn/pub',
    },
    en: {
      src: 'https://docs.google.com/document/d/e/2PACX-1vTNrtaO3Ahs_vUSEeEeV3YErNsagVwKZLGuQu2y7HmilEUFu-woFX_vxAm7YCJApr9d_affLv3jNZc0/pub',
    },
  },
};
